/**
 * @generated SignedSource<<1e60648982b7918818320f1a67bbdaec>>
 * @relayHash b46967809a67fdb9592852f9c5afab66
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/567.0.0-2026-07-09T16:56:40.576Z/nftItemUpdateSubscription

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemUpdateSubscriptionInput = {
  itemId: string;
};
export type nftItemUpdateSubscription$variables = {
  fetchSplitName?: boolean | null;
  fetchUser: boolean;
  input: NftItemUpdateSubscriptionInput;
  userId: string;
};
export type nftItemUpdateSubscription$data = {
  readonly nftItemUpdate: {
    readonly nftItem: {
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContext_nftItem" | "NftPdpLiveDetails_nftItem">;
    } | null;
    readonly nftItemHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistory_nftItemHistory">;
    } | null;
  } | null;
};
export type nftItemUpdateSubscription = {
  response: nftItemUpdateSubscription$data;
  variables: nftItemUpdateSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchSplitName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v6/*:: as any*/),
  (v7/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v7/*:: as any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        (v7/*:: as any*/)
      ],
      "storageKey": null
    },
    (v7/*:: as any*/)
  ],
  "storageKey": null
},
v12 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allocation",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basisPoints",
  "storageKey": null
},
v16 = [
  (v6/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftSplit",
    "kind": "LinkedField",
    "name": "split",
    "plural": false,
    "selections": [
      {
        "condition": "fetchSplitName",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "NftSplitBookmark",
            "kind": "LinkedField",
            "name": "bookmark",
            "plural": false,
            "selections": [
              (v13/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "distributorFee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EthereumAddressType",
        "kind": "LinkedField",
        "name": "controllerAddress",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v10/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NftSplitAllocation",
        "kind": "LinkedField",
        "name": "allocations",
        "plural": true,
        "selections": [
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ],
    "storageKey": null
  },
  (v7/*:: as any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "ownerAddress",
  "plural": false,
  "selections": (v8/*:: as any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "sellerAddress",
  "plural": false,
  "selections": (v8/*:: as any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ether",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wei",
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "NftConversionRateEvent",
  "kind": "LinkedField",
  "name": "endedConversionRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": (v21/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v25 = [
  (v19/*:: as any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicProfileUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDibsAddress",
  "storageKey": null
},
v28 = [
  (v6/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAddressZero",
    "storageKey": null
  },
  (v26/*:: as any*/),
  (v9/*:: as any*/),
  (v27/*:: as any*/),
  (v10/*:: as any*/),
  (v7/*:: as any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "from",
  "plural": false,
  "selections": (v28/*:: as any*/),
  "storageKey": null
},
v30 = [
  (v6/*:: as any*/),
  (v26/*:: as any*/),
  (v9/*:: as any*/),
  (v27/*:: as any*/),
  (v10/*:: as any*/),
  (v7/*:: as any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "auction",
  "plural": false,
  "selections": [
    (v22/*:: as any*/),
    (v7/*:: as any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "to",
  "plural": false,
  "selections": (v28/*:: as any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "operator",
  "plural": false,
  "selections": (v8/*:: as any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "nftItemUpdateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "NftItemUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItem",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftPdpLiveDetails_nftItem"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftPdpBidModalContext_nftItem"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemHistory",
            "kind": "LinkedField",
            "name": "nftItemHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftPdpHistory_nftItemHistory"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscriptions",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "nftItemUpdateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "NftItemUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceId",
                "storageKey": null
              },
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "addressWithFields",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": (v8/*:: as any*/),
                        "storageKey": null
                      },
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentAddresses",
                "kind": "LinkedField",
                "name": "paymentAddresses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentAddress",
                    "kind": "LinkedField",
                    "name": "addresses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": (v16/*:: as any*/),
                        "storageKey": null
                      },
                      (v14/*:: as any*/),
                      (v15/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v12/*:: as any*/),
                    "concreteType": "NftItemBalance",
                    "kind": "LinkedField",
                    "name": "balanceForUser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "balance",
                        "storageKey": null
                      },
                      (v7/*:: as any*/),
                      (v17/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "auctionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "winnerAddress",
                    "plural": false,
                    "selections": (v8/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "fundsRecipient",
                    "plural": false,
                    "selections": (v16/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EtherAmount",
                    "kind": "LinkedField",
                    "name": "reservePrice",
                    "plural": false,
                    "selections": [
                      (v19/*:: as any*/),
                      (v20/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EtherAmount",
                    "kind": "LinkedField",
                    "name": "currentBid",
                    "plural": false,
                    "selections": [
                      (v20/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isERC1155",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EtherRates",
                "kind": "LinkedField",
                "name": "etherRates",
                "plural": true,
                "selections": (v21/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v23/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftDigitalArtMetadataMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "webUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "posterFrameUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "NftDigitalArtMetadata",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*:: as any*/),
              {
                "alias": "lastLiveAuction",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "excludeCanceled",
                    "value": true
                  }
                ],
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  (v18/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": "mostRecentAuction(excludeCanceled:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edition",
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemHistory",
            "kind": "LinkedField",
            "name": "nftItemHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v24/*:: as any*/),
                "concreteType": "NftItemHistoryEventsConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemHistoryEventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNftItemHistoryEvent"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "transactionHash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": (v25/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v29/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": (v30/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryTransferEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v31/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "reservePrice",
                                "plural": false,
                                "selections": (v25/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "auctionCreator",
                                "plural": false,
                                "selections": (v30/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionCreatedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v31/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "bidAmount",
                                "plural": false,
                                "selections": (v25/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "bidder",
                                "plural": false,
                                "selections": (v30/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionBidEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPaused",
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionPausedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v31/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "winningBid",
                                "plural": false,
                                "selections": (v25/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "winningBidder",
                                "plural": false,
                                "selections": (v30/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionEndedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "canceledBy",
                                "plural": false,
                                "selections": (v30/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionCanceledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "valueArg",
                                "storageKey": null
                              },
                              (v29/*:: as any*/),
                              (v32/*:: as any*/),
                              (v33/*:: as any*/)
                            ],
                            "type": "NftItemHistoryTransferSingleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ids",
                                "storageKey": null
                              },
                              (v29/*:: as any*/),
                              (v32/*:: as any*/),
                              (v33/*:: as any*/)
                            ],
                            "type": "NftItemHistoryTransferBatchEvent",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "events(first:6)"
              },
              {
                "alias": null,
                "args": (v24/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "NftPdpHistory_events",
                "kind": "LinkedHandle",
                "name": "events"
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/567.0.0-2026-07-09T16:56:40.576Z/nftItemUpdateSubscription",
    "metadata": {},
    "name": "nftItemUpdateSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "e3c85191b6636376e8f6bfb1a2f808c8";

export default node;
